var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","dense":"","return-object":"","hide-details":"auto","item-text":"name","label":_vm.$t('label.choose-set-number'),"require":"","items":_vm.items,"rules":_vm.rules},model:{value:(_vm.selectItem),callback:function ($$v) {_vm.selectItem=$$v},expression:"selectItem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }